import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateLeadsViews } from '../../../lib/query/invalidateResource';
import { closeLead } from '../api/leads';
import type { CloseLeadPayload } from '../types';
import { notification } from 'antd';
import { ApiError } from '../../../lib/api/error';

interface CloseLeadParams {
  leadId: string;
  payload: CloseLeadPayload;
}

export function useCloseLead() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ leadId, payload }: CloseLeadParams) => closeLead(leadId, payload),
    onSuccess: (_, variables) => {
      notification.success({ message: 'Lead closed' });
      invalidateLeadsViews(queryClient);
      void queryClient.invalidateQueries({ queryKey: ['lead', variables.leadId] });
    },
    onError: (error) => {
      notification.error({ message: ApiError.fromAxiosError(error).message });
    },
  });
}
